<div class="row">
    <div class="col-xs-12">
        <div class="card card--box card--box--dashboard">
            <div class="col-sm-10 col-xs-12 p-0 mx-auto card--box--dashboard__header">
                <h2 class="header">
                    {{ 'Tokens' | translate }}
                </h2>
            </div>
            <div class="col-sm-2 col-xs-12 p-0 mx-auto card--box--dashboard__header">
                <button type="button" class="btn btn-secondary btn-create-token" [routerLink]="['create']">
                    <i class="fal fa-plus-circle mr-r--xs"></i>
                    {{ 'Create token' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="col-xs-12" *ngIf="items.length; else empty">
        <div class="table--grid card--box--dashboard__body">
            <div class="table--grid__body">
                <div class="row">
                    <!--table headers-->
                    <div class="col-xs-12">
                        <div class="row">
                            <ng-container *ngFor="let column of tableColumns">
                                <div *ngIf="column[0] === 'created_at_diff'" class="{{ column[2] }}" 
                                    (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                    <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                        {{ column[1] | translate }}
                                    </span>
                                </div>
                                <div *ngIf="column[0] !== 'created_at_diff'" class="{{ column[2] }}">
                                    <span>
                                        {{ column[1] | translate }}
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <!--table cells-->
                <div *ngFor="let item of items" class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}" [class.archived]="!item['active']" [class.description]="column[0] === 'description'">
                                <span *ngIf="column[3] === 'token'">
                                    {{ item[column[0]] }}
                                    <span class="mr-l--sm">
                                        <i class="far fa-copy" (click)="copyText(item[column[0]])" tooltip="{{tokenText | translate}}" container="body" placement="top"></i>
                                    </span>
                                    <span class="mr-l--sm">
                                        <i class="far fa-link" (click)="copyText(this.konektoDomain + '/?token=' + item[column[0]])" tooltip="{{tokenUrl | translate}}" container="body" placement="top"></i>
                                    </span>
                                </span>
                                <span *ngIf="column[0] === 'created_at_diff' || column[0] === 'inactive_at_diff' || column[0] === 'last_used_diff'">
                                    <ng-container *ngIf="column[0] === 'inactive_at_diff' && item[column[0]]">
                                        {{ 'Archived' | translate }}
                                    </ng-container>
                                    {{ item[column[0]] | dateDiffTranslate}}
                                </span>
                                <span *ngIf="column[0] === 'description' || column[0] === 'usages'">
                                    {{ item[column[0]] }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <pagination-component [(page)]="currentPage" [total]="totalItems" [perPage]="itemsPerPage"
        [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)"
        #pagination></pagination-component>
    </div>

    <ng-template #empty>
        <div class="row">
            <div class="col-xs-12 text-xs-center mr-t--md">
                {{ 'There is no token yet.' | translate }}
            </div>
        </div>
    </ng-template>
</div>

<router-outlet></router-outlet>
